import React from 'react'
import 'semantic-ui-css/semantic.min.css'
import { Label } from 'semantic-ui-react'

const FilterStatusButton = ({
  statusFilter,
  onTransactionTabPress,
  totalTransactions: total,
  reconciledCount,
  notMatchedCount,
  unreconciledCount,
  delta0Count,
} = {}) => {
  return (
    <div className="transaction-filter ui buttons">
      <button
        type="button"
        className={` transaction-filter-button ui button  ${statusFilter === "all" ? "active" : ""}`}
        onClick={() => onTransactionTabPress("all")}
      >
        All
        <Label className="label-filter" circular color="black">{total}</Label>
      </button>
      <button
        type="button"
        className={`transaction-filter-button ui button  ${statusFilter === "Reconciled" ? "active" : ""}`}
        onClick={() => onTransactionTabPress("Reconciled")}
      >
        Reconciled
        <Label className="label-filter" circular color="custom-label-green">{reconciledCount}</Label>
      </button>
      <button
        type="button"
        className={`transaction-filter-button ui button  ${statusFilter === "Unreconciled" ? "active" : ""}`}
        onClick={() => onTransactionTabPress("Unreconciled")}
      >
        Unreconciled
        <Label className="label-filter" circular color="custom-label-orange">{unreconciledCount}</Label>
      </button>
      <button
        type="button"
        className={`transaction-filter-button ui button  ${statusFilter === "Unmatched" ? "active" : ""}`}
        onClick={() => onTransactionTabPress("Unmatched")}
      >
        Unmatched
        <Label className="label-filter" circular color="custom-label-red">{notMatchedCount}</Label>
      </button>
      <button
        type="button"
        className={`transaction-filter-button ui button  ${statusFilter === "Delta0" ? "active" : ""}`}
        onClick={() => onTransactionTabPress("Delta0")}
      >
        Delta0
        <Label className="label-filter" circular color="custom-label-grey">{delta0Count}</Label>
      </button>
    </div>
  )
}

export default FilterStatusButton
